import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import CircledIcon from '../../../components/CircledIcon';
import Support from '../../../components/Support';
import SupportMobile from '../../../components/Support/SupportMobile';
import Switch from '../../../components/Switch';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const RetireOnlineOptionsStep = ({ data, collectStepData }: StepProps) => {
  const handleContinueToPayOption = () => {
    collectStepData({
      ...data,
      continueToPayOption: !data.continueToPayOption ? 'checked ' : undefined,
    });
  };

  const handleLargerBenefitOption = () => {
    collectStepData({
      ...data,
      largeBenefitOption: !data.largeBenefitOption ? 'checked ' : undefined,
    });
  };

  const handleSSOption = () => {
    collectStepData({
      ...data,
      SSOption: !data.SSOption ? 'checked ' : undefined,
    });
  };

  const handleLumpSumOption = () => {
    collectStepData({
      ...data,
      lumpSumOption: !data.lumpSumOption ? 'checked ' : undefined,
    });
  };

  return (
    <Container className="p-0 d-flex flex-row">
      <section className={'col-12 col-lg-9'}>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h5 className={'mt-12 text-sm-20-lg-24'}>Select Options</h5>
          <div className={'mt-12 text-sm-20-lg-24 d-lg-none'}>
            <SupportMobile>
              <div className="p-0 mt-4">
                <span className="fw-bold text-caption">
                  Retirement Case Administrator
                </span>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('user-headset')}
                    label="Jessica Wright"
                  />
                </div>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('phone')}
                    label="1-800-888-8888 x 1234"
                  />
                </div>
              </div>
            </SupportMobile>
          </div>
        </div>

        <div className={'mt-10 text-fs-6 lh-xs fw-light'}>
          <p>
            Retirement plans can have hundreds of Optional Forms of payment to
            choose from. In order to provide you with those most important to
            you please provide the information below.
          </p>
        </div>
        <h6 className={'mt-10 text-fs-6 fw-normal'}>
          I am Interested in considering:
        </h6>

        <Container className={'mt-7 p-0 text-fs-6'}>
          <Row className={'py-4 m-0 lh-xs border-bottom border-info'}>
            <Col className={'d-flex p-0'}>
              <span className={'me-auto fw-light'}>
                Options that continue to pay benefits to my survivors after my
                death
              </span>
              <div className={'ms-5'}>
                <Switch
                  onChange={handleContinueToPayOption}
                  value={data.continueToPayOption}
                  defaultChecked={data.continueToPayOption}
                  variant="md"
                  id="s1"
                />
              </div>
            </Col>
          </Row>

          <Row className={'py-4 m-0 lh-xs border-bottom border-info'}>
            <Col className={'d-flex p-0'}>
              <span className={'me-auto fw-light'}>
                Options that may provide a larger benefit while I'm alive but do
                not pay benefits upon my death
              </span>
              <div className={'ms-5'}>
                <Switch
                  onChange={handleLargerBenefitOption}
                  value={data.largeBenefitOption}
                  defaultChecked={data.largeBenefitOption}
                  variant="md"
                  id="s2"
                />
              </div>
            </Col>
          </Row>

          <Row className={'py-4 m-0 lh-xs border-bottom border-info'}>
            <Col className={'d-flex p-0'}>
              <span className={'me-auto fw-light'}>
                Options that pay larger benefit until Social Security start and
                lower after Social Security
              </span>
              <div className={'ms-5'}>
                <Switch
                  onChange={handleSSOption}
                  value={data.SSOption}
                  defaultChecked={data.SSOption}
                  variant="md"
                  id="s3"
                />
              </div>
            </Col>
          </Row>

          <Row className={'py-4 m-0 lh-xs'}>
            <Col className={'d-flex p-0'}>
              <span className={'me-auto fw-light'}>A Lump Sum Option</span>
              <div className={'ms-5'}>
                <Switch
                  onChange={handleLumpSumOption}
                  value={data.lumpSumOption}
                  defaultChecked={data.lumpSumOption}
                  variant="md"
                  id="s4"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="d-none d-lg-flex justify-content-lg-end col-lg-3">
        <section className="mt-12">
          <Support>
            <div className="p-0 mt-4">
              <span className="fw-bold text-caption">
                Retirement Case Administrator
              </span>
              <div className="mt-4">
                <CircledIcon
                  icon={light('user-headset')}
                  label="Jessica Wright"
                />
              </div>
              <div className="mt-4">
                <CircledIcon
                  icon={light('phone')}
                  label="1-800-888-8888 x 1234"
                />
              </div>
            </div>
          </Support>
        </section>
      </div>
    </Container>
  );
};

export default RetireOnlineOptionsStep;
